

















































import Vue from 'vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

export default Vue.extend({
  components: { ErrorMessage },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      validationCode: '',
      hasFocus: false,
      validationCodeLength: 6,
    };
  },
  computed: {
    hasError(): boolean {
      return Boolean(this.error);
    },
  },
  watch: {
    validationCode(value: string, previousValue: string) {
      if (value.length < previousValue.length) this.$emit('clear');
      if (value.length === this.validationCodeLength) this.$emit('done', value);
    },
  },
  mounted() {
    this.$nextTick(this.setFocus);
  },
  methods: {
    blurHandler() {
      this.hasFocus = false;
    },
    focusHandler() {
      this.hasFocus = true;
    },
    isHighlighted(index: number): boolean {
      const isFilled = index < this.validationCode.length;
      const isCursorActive = this.showCursor(index) && this.hasFocus;

      return isFilled || isCursorActive;
    },
    onlyAllowNumbers(event: Event) {
      const evt: any = event;

      evt.returnValue = /\d+/.test(evt.key);
    },
    preventSelection(event: any) {
      const inputRef = this.$refs.validationCodeInput as HTMLInputElement;

      inputRef.selectionStart = inputRef.selectionEnd;
    },
    setFocus() {
      const inputRef = this.$refs.validationCodeInput as HTMLInputElement;

      inputRef.focus();
    },
    showCursor(index: number): boolean {
      const isLastChar = index === this.validationCode.length;
      const isCodeEmpty = index === 0 && this.validationCode.length === 0;

      return isLastChar || isCodeEmpty;
    },
    validationCodeCharAt(index: number): string {
      return this.validationCode.charAt(index);
    },
  },
});
